var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderPromiseBroken(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CD051F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.905 0c-1.983-.007-3.849.928-5.017 2.514-.244.339-.277.784-.084 1.154l.508 1.005c.176.348.157.761-.051 1.091l-1.069 1.7c-.228.361-.228.82 0 1.18l1.041 1.65c.222.352.23.797.018 1.156l-1.097 1.853c-.205.349-.205.78 0 1.129l1.122 1.903c.197.332.206.742.026 1.083l-1.295 2.463c.365.183.801.153 1.137-.077l3.342-2.306c1.924-1.362 3.76-2.853 5.192-4.736 1.231-1.618 2.13-3.539 2.298-5.55C24.27 3.532 21.866 0 17.905 0z",
    transform: "translate(4 6.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.257 17.598s2.203 1.585 3.243 2.324c.041.027.083.055.122.078l1.253-2.473c.174-.343.165-.755-.025-1.09l-1.081-1.914c-.198-.35-.198-.784 0-1.135l1.057-1.863c.205-.36.198-.81-.017-1.163l-1.004-1.66c-.218-.363-.218-.823 0-1.187l1.03-1.715c.2-.332.22-.747.05-1.097-.49-1.03-.945-2.058-1.743-2.883C9.016.652 7.484-.004 5.887 0 2.067 0-.267 3.552.024 7.254c.16 2.023 1.02 3.962 2.203 5.59 1.387 1.887 3.178 3.384 5.03 4.754z",
    transform: "translate(4 6.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPromiseBroken);
export default __webpack_public_path__ + "static/media/order-promise-broken.31f649b06a003e5bedf4cb5d94916033.svg";
export { ForwardRef as ReactComponent };